import http from "../httpService";
const apiUrl = http.getApiURL();

export function getNextCode(menuItemCode, trxDate) {
  const config = {
    headers: {
      MenuItemCode: menuItemCode,
    },
  };
  let url = `${apiUrl}/AwbSales/GetNextCode?TrxDate=${trxDate}`;

  return http.get(url, config);
}

export function getAwbData(menuItemCode, awbNo) {
  const config = {
    headers: {
      MenuItemCode: menuItemCode,
    },
  };
  let url = `${apiUrl}/AwbSales/GetAwbData?AwbNo=${awbNo}`;

  return http.get(url, config);
}
